/**
 * Schedule results tab for non–Football3D sports.
 * Single component with unified logic; sport-specific behaviour via scheduleResultsConfig.
 */
import React from 'react';
import ScheduleResultsTabContent from 'features/markets/components/bets-area/ScheduleResultsTabContent';

export default function GenericScheduleResultsTab({ sportId }) {
  return <ScheduleResultsTabContent sportId={sportId} />;
}
